var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverviewActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2298 3.87519L16.2298 3.87519V3.88V4.82C16.2298 5.58386 15.6136 6.2 14.8498 6.2H10.1398C9.37591 6.2 8.75977 5.58386 8.75977 4.82V3.88C8.75977 3.11959 9.38245 2.5 10.1498 2.5H14.8498C15.6181 2.5 16.2371 3.11947 16.2298 3.87519Z",
    fill: "#0063F6",
    stroke: "#0063F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.85 8.20949C16.7162 8.20949 18.24 6.68563 18.24 4.81949C18.24 4.65295 18.4252 4.5187 18.6077 4.61226C19.8589 5.27894 20.71 6.60178 20.71 8.11949V17.5295C20.71 19.7134 18.9239 21.4995 16.74 21.4995H8.26004C6.07618 21.4995 4.29004 19.7133 4.29004 17.5295V8.11949C4.29004 6.60178 5.14117 5.27893 6.39236 4.61225C6.5749 4.51871 6.76004 4.65296 6.76004 4.81949C6.76004 6.68563 8.2839 8.20949 10.15 8.20949H14.85ZM8.50004 17.4495H12.88C13.5662 17.4495 14.13 16.8856 14.13 16.1995C14.13 15.5134 13.5662 14.9495 12.88 14.9495H8.50004C7.8139 14.9495 7.25004 15.5134 7.25004 16.1995C7.25004 16.8856 7.8139 17.4495 8.50004 17.4495ZM8.50004 13.4495H15.5C16.1862 13.4495 16.75 12.8856 16.75 12.1995C16.75 11.5133 16.1862 10.9495 15.5 10.9495H8.50004C7.8139 10.9495 7.25004 11.5133 7.25004 12.1995C7.25004 12.8856 7.8139 13.4495 8.50004 13.4495Z",
    fill: "#0063F6",
    stroke: "#0063F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewActive);
export default __webpack_public_path__ + "static/media/overview-active.0619686ef57de550480e5e37fe7e812d.svg";
export { ForwardRef as ReactComponent };